var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { entities } from "sbtech-sports-data-api-client";
/**
* Selection defines model for selection object information
*
* @typedef Selection
* @type {Object}
* @property {id} BranchId identifier
* @property {title} Title of the Selection
* @property {odds} Odds of the Selection
* @property {points} points type number
*/
export var SelectionSide;
(function (SelectionSide) {
    SelectionSide[SelectionSide["Home"] = 1] = "Home";
    SelectionSide[SelectionSide["Draw"] = 2] = "Draw";
    SelectionSide[SelectionSide["Away"] = 3] = "Away";
})(SelectionSide || (SelectionSide = {}));
export var OddStyles;
(function (OddStyles) {
    OddStyles["decimal"] = "decimal";
    OddStyles["american"] = "american";
    OddStyles["fractional"] = "fractional";
    OddStyles["indo"] = "indo";
    OddStyles["malay"] = "malay";
    OddStyles["hk"] = "hk";
})(OddStyles || (OddStyles = {}));
const SelectionSideByOutcomeType = {
    [entities.OutcomeType.Home]: (s) => s.isSwapped ? SelectionSide.Away : SelectionSide.Home,
    [entities.OutcomeType.Away]: (s) => s.isSwapped ? SelectionSide.Home : SelectionSide.Away,
    [entities.OutcomeType.Over]: (s) => SelectionSide.Home,
    [entities.OutcomeType.Under]: (s) => SelectionSide.Away,
    [entities.OutcomeType.Draw]: (s) => SelectionSide.Draw,
    [entities.OutcomeType.Tie]: (s) => SelectionSide.Draw,
};
export class Selection {
    constructor(selectionData) {
        this.id = selectionData.id;
        this.title = selectionData.title;
        this.points = selectionData.points;
        this.odds = selectionData.odds;
        this.trueOdds = selectionData.trueOdds;
        this.formattedPoint = selectionData.points.toString();
        this.formattedOdds = selectionData.odds;
        this.lineGroupId = selectionData.lineGroupId;
        this.outcomeType = selectionData.outcomeType;
        this.displayOdds = selectionData.displayOdds;
        this.isDisabled = selectionData.isDisabled;
        this.isSelected = selectionData.isSelected;
        this.isSwapped = selectionData.isSwapped;
        this.sbtechId = selectionData.sbtechId;
        this.betslipLine = selectionData.betslipLine;
        this.group = selectionData.group;
        this.tags = selectionData.tags;
        this.status = selectionData.status;
        this.participantMapping = selectionData.participantMapping;
    }
    update(selection) {
        this.points = selection.points;
        this.odds = selection.odds;
        this.isDisabled = selection.isDisabled;
    }
    updateIsSelected(value) {
        this.isSelected = value;
    }
    updateIsDisabled(value) {
        this.isDisabled = value;
    }
    updateOdds(odds) {
        this.odds = odds;
    }
    updateFormattedOdds(formattedOdds) {
        this.formattedOdds = formattedOdds;
    }
    updateFormattedPoint(formattedPoint) {
        this.formattedPoint = formattedPoint;
    }
    /* istanbul ignore next */
    getSide() {
        return SelectionSideByOutcomeType[this.outcomeType] && SelectionSideByOutcomeType[this.outcomeType](this);
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], Selection.prototype, "points", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Selection.prototype, "displayOdds", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Selection.prototype, "odds", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Selection.prototype, "trueOdds", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Selection.prototype, "isDisabled", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Selection.prototype, "isSelected", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Selection.prototype, "formattedOdds", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Selection.prototype, "formattedPoint", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Selection]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "update", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "updateIsSelected", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "updateIsDisabled", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "updateOdds", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "updateFormattedOdds", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Selection.prototype, "updateFormattedPoint", null);
//# sourceMappingURL=Selection.js.map